import { MonthLogs } from '../../api/api-types';
import { GET_TIME_TRACKED_DATA } from '../actions';

export const getTimeTrackedDataAction = (data: MonthLogs) =>
  GET_TIME_TRACKED_DATA({ payload: data });
